
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Beneficio</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitBenefir(objectGroupForm)" #objectGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="object.description" [(ngModel)]="object.description">
								<mat-error>{{ violations['object.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="object.code" [(ngModel)]="object.code" (keydown.space)="$event.preventDefault()">
								<mat-error>{{ violations['object.code'] }}</mat-error>
							</mat-form-field>
						</div>
                        <!--div class="control">
                            <mat-form-field class="controlWidth">
                              <mat-label>Tipo Beneficio</mat-label>
                              <mat-select [(ngModel)]="object.objectType"  [compareWith]="compareObjectTypes" name="object.objectType" >
                              @for (objectType of objectTypes ; track objectType.id) {
                                <mat-option [value]="objectType">{{ objectType.description }}</mat-option>
                              }
                            </mat-select>
							<mat-error>{{ violations['object.objectType'] }}</mat-error>
							<mat-error *ngIf="violations['object.objectType']">
								{{ violations['object.objectType'] }}
							  </mat-error>
                            </mat-form-field>
                        </div-->
						<div class="control">
							<mat-slide-toggle [(ngModel)]="object.active"  name="objectActive" > 
							  {{ object.active? 'Beneficio Activo':'Beneficio Inactivo'}} 
							</mat-slide-toggle>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(object.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>